import React, {Fragment, useContext, useEffect} from "react"

import WieldySidebarSection from "root/Wieldy/Sidebar/WieldySidebarSection";
import WieldySidebarClick from "root/Wieldy/Sidebar/WieldySidebarClick";
import AdminModuleContext from "../AdminModuleContext";

const AdminOrganisationSubmenu = (props ) =>
{
    // The organisation Context renders the add/edit organisation modal so we don't have to render it twice
    const domains = useContext(AdminModuleContext) ;

    return (
        <Fragment key='ky'>
            <WieldySidebarSection key='sbs' title='New Domain' >
                <WieldySidebarClick modal={() => domains.activateDomainModal( null, 'create')} title='Domain' iconName='icon-add-circle' iconSize='icon-xl' keyName='ocb' key='ocn'/>
            </WieldySidebarSection>
        </Fragment>
    )
}

export default AdminOrganisationSubmenu ;